import _ from 'lodash';
import React from 'react';
import {
  ProjectTaskFilter,
  ProjectTaskRecordStatusFilter,
  ProjectTaskStatusFilter,
  ProjectTaskTagFilter,
} from '~/components';
import FiltersGroup from './FiltersGroup';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function TaskFiltersGroup({ filters, onChange }) {
  return (
    <FiltersGroup
      label="Task Filters"
      filters={[
        filters.projectTasks,
        filters.projectTaskRecordStatusId,
        filters.projectTaskStatuses,
        filters.projectTaskTags,
        filters.projectTaskStartDatePeriod?.start,
        filters.projectTaskStartDatePeriod?.end,
        filters.projectTaskEndDatePeriod?.start,
        filters.projectTaskEndDatePeriod?.end,
      ]}>
      {_.has(filters, 'projectTasks') && filters.projects?.length === 1 && (
        <ProjectTaskFilter
          project={filters.projects[0]}
          value={filters.projectTasks}
          onChange={({ target: { value } }) => onChange({ projectTasks: value })}
        />
      )}

      {_.has(filters, 'projectTaskStatuses') && (
        <ProjectTaskStatusFilter
          value={filters.projectTaskStatuses}
          onChange={({ target: { value } }) => onChange({ projectTaskStatuses: value })}
        />
      )}

      {_.has(filters, 'projectTaskRecordStatusId') && (
        <ProjectTaskRecordStatusFilter
          value={filters.projectTaskRecordStatusId}
          onChange={({ target: { value } }) => onChange({ projectTaskRecordStatusId: value })}
        />
      )}

      {_.has(filters, 'projectTaskTags') && (
        <ProjectTaskTagFilter
          value={filters.projectTaskTags}
          onChange={({ target: { value } }) => onChange({ projectTaskTags: value })}
        />
      )}

      {_.has(filters, 'projectTaskStartDatePeriod') && (
        <div data-testid="task-start-date-filter">
          <ReportPeriodFilter
            placeholder="Task Start Date"
            value={filters.projectTaskStartDatePeriod}
            onChange={({ target: { value } }) => onChange({ projectTaskStartDatePeriod: value })}
          />
        </div>
      )}

      {_.has(filters, 'projectTaskEndDatePeriod') && (
        <div data-testid="task-end-date-filter">
          <ReportPeriodFilter
            placeholder="Task End Date"
            value={filters.projectTaskEndDatePeriod}
            onChange={({ target: { value } }) => onChange({ projectTaskEndDatePeriod: value })}
          />
        </div>
      )}
    </FiltersGroup>
  );
}
